var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigplus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    fill: "white",
    stroke: "#D5D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4329 12.0001C18.4328 11.5263 18.049 11.1424 17.5751 11.1424L12.857 11.1432L12.8566 6.42618C12.8565 5.95235 12.4727 5.5685 11.9988 5.56847C11.525 5.56845 11.1412 5.95221 11.1413 6.42603L11.1417 11.143L6.42471 11.1426C5.95087 11.1426 5.56709 11.5264 5.56715 12.0002C5.56721 12.474 5.95104 12.8579 6.42486 12.8579L11.1419 12.8583L11.1423 17.5753C11.1423 18.0491 11.5262 18.433 12 18.433C12.4738 18.433 12.8576 18.0493 12.8575 17.5754L12.8571 12.8584L17.5741 12.8589C18.0479 12.8589 18.4317 12.4751 18.4317 12.0013L18.4329 12.0001Z",
    fill: "#7D8693"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigplus);
export default __webpack_public_path__ + "static/media/bigplus.1a9ebbf3424465ff304dd4c68e9a69ec.svg";
export { ForwardRef as ReactComponent };